export type ColorLabelSource = {
  colorCode?: string | null;
  labelEn?: string | null;
  labelAr?: string | null;
};

export const normalizeColorCode = (value?: string | null): string => {
  const trimmed = String(value || '').trim().toLowerCase();
  if (!trimmed) {
    return '';
  }
  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  if (/^#[0-9a-f]{3}$/.test(withHash)) {
    return `#${withHash[1]}${withHash[1]}${withHash[2]}${withHash[2]}${withHash[3]}${withHash[3]}`;
  }
  return withHash;
};

export const buildColorLabelByCode = (
  colors: ColorLabelSource[]
): Map<string, string> => {
  const map = new Map<string, string>();
  for (const color of colors) {
    const code = normalizeColorCode(color.colorCode);
    if (!code) {
      continue;
    }
    const labelEn = String(color.labelEn || '').trim();
    const labelAr = String(color.labelAr || '').trim();
    map.set(code, labelEn || labelAr || code);
  }
  return map;
};

export const getColorDisplayLabel = (
  colorCode: string | null | undefined,
  labelByCode: Map<string, string>,
  fallback = 'N/A'
): string => {
  const normalized = normalizeColorCode(colorCode);
  if (!normalized) {
    return fallback;
  }

  const label = labelByCode.get(normalized);
  if (label && label.toLowerCase() !== normalized) {
    return `${label} (${normalized})`;
  }

  return normalized;
};
